/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandGitlab = createReactComponent("brand-gitlab", "IconBrandGitlab", [
  ["path", { d: "M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7z", key: "svg-0" }]
]);

export { IconBrandGitlab as default };
//# sourceMappingURL=IconBrandGitlab.js.map
